<template>
  <div class="invite-doctor">
    <div class="invite-title"><img src="@/assets/images/invite-title.png"></div>
    <div class="invite-card">
      <div class="qrcode"><img :src="codeData.url" v-if="codeData.url" alt=""></div>
      <p>扫描二维码入驻喜乐互联网医院</p>
      <!-- <div class="save-button"><button>保存到相册</button></div> -->
    </div>
  </div>
</template>

<style lang="less" scoped>
  .invite-doctor{
    width: 100%;
    height: 100vh;
    background: @linear;
    padding: 48px 20px 0;
    .invite-title{
      padding: 0 20px;
      img{
        width: 100%;
      }
    }
    .invite-card{
      margin-top: 28px;
      padding: 48px 48px 40px;
      background: #FFF;
      border-radius: 6px;
      box-shadow: @box-shadow;
      text-align: center;
      .qrcode{
        width: 200px;
        height: 200px;
        overflow: hidden;
        margin: 0 auto;
        img{
          width: 100%;
          // pointer-events: none;
        }
      }
      p{
        margin-top: 12px;
        font-size: 14px;
        line-height: 14px;
        color: #666;
      }
      .save-button{
        margin: 60px auto 0;
        width: 240px;
        button{
          @button-base();
          width: 100%;
          height: 36px;
          font-size: 14px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        codeData: {}
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      this.$root.post('/getDoctorQrcode', {
        doc_id: this.userInfo.user_id,
        type: 2
      }).then(data => {
        console.log(data)
        this.codeData = data;
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Invite/doctor.vue